export default __webpack_public_path__ + "static/media/Legguards of the Milites Templi.7ff4b1e1.jpg";